<template>
  <transition
    appear
    name="fade"
  >
    <div
      v-if="show"
      class="-mx-4 p-4 bg-gray-100 lg:m-0 lg:p-0 lg:bg-white"
    >
      <h3
        ref="heading"
        class="lg:font-bold font-bold"
      >
        Order Summary
      </h3>
      <div class="mt-4 text-base">
        <div class="flex items-center justify-between font-bold">
          <p>Item</p>
          <p>Price</p>
        </div>
        <div class="flex items-center justify-between mt-2">
          <p class="max-w-1/2">
            Identity Verification Fee (Required)
          </p>
          <p ref="icoaAmount">
            {{ icoaAmountFormatted }}
          </p>
        </div>
        <div
          v-if="informedDelivery"
          class="flex items-center justify-between mt-2"
        >
          <p class="max-w-1/2">
            Informed Delivery
          </p>
          <div class="flex w-1/2 justify-between">
            <button
              ref="removeBtn"
              type="button"
              class="flex items-center text-sm text-blue-200 underline"
              @click="$emit('clear-selection-informed')"
            >
              <img
                :src="$options.iconCloseNb"
                alt="close icon"
                class="w-2 mr-2"
              >
              Remove
            </button>
            <p ref="informedDeliveryAmount">
              $0.00
            </p>
          </div>
        </div>
        <div
          v-if="extensionPeriod"
          class="flex items-center justify-between mt-2"
        >
          <p
            ref="extPeriod"
            class="max-w-1/2"
          >
            {{ `${extensionPeriod}-month Mail Forwarding Extension` }}
          </p>
          <div class="flex w-1/2 justify-between">
            <button
              ref="removeBtn"
              type="button"
              class="flex items-center text-sm underline text-blue-200"
              @click="$emit('clear-selection')"
            >
              <img
                :src="$options.iconCloseNb"
                alt="close icon"
                class="w-2 mr-1"
              >
              Remove
            </button>
            <p ref="extCost">
              {{ extensionCostFormatted }}
            </p>
          </div>
        </div>
        <div class="c-hairline mt-2" />
        <div class="flex items-center justify-between mt-2 font-bold">
          <p>Total due:</p>
          <p ref="total">
            {{ totalAmount }}
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import iconCloseNb from '../assets/choice/icon_close_nb.svg';

export default {
  name: 'ExtensionSummary',
  props: {
    extensionCost: {
      type: String,
      required: false,
      default: '',
      example: '19.95',
    },
    extensionPeriod: {
      type: Number,
      required: false,
      default: 0,
      example: 6,
    },
    icoaAmount: {
      type: Number,
      required: true,
      example: 105,
    },
    informedDelivery: {
      type: Boolean,
      required: true,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    extensionCostFormatted() {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(Number(this.extensionCost));
    },
    icoaAmountFormatted() {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(this.icoaAmount / 100);
    },
    totalAmount() {
      const extensionCostNum = Number(this.extensionCost) || 0;
      const totalNum = (this.icoaAmount / 100) + extensionCostNum;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(totalNum);
    },
  },
  iconCloseNb,
};
</script>
